import gql from 'graphql-tag'
import { putUnavailability, removeUnavailability } from 'src/services/duty'
import { useHandler } from 'labguard-cdk'
import { useAccountId } from 'src/hooks'
import { useMutation } from 'react-apollo'
import useSelectedUserId from './useSelectedUserId'
import useSelectedUserUnavailabilities from './useSelectedUserUnavailabilities'

const accountMutation = gql`
  mutation updateAccountUnavailabilities($unavailabilities: [PeriodInput]!) {
    updateAccountUnavailabilities(unavailabilities: $unavailabilities) {
      id
      unavailabilities {
        from
        to
      }
    }
  }
`

const userMutation = gql`
  mutation updateUserUnavailabilities($userId: ID!, $unavailabilities: [PeriodInput]!) {
    updateUserUnavailabilities(userId: $userId, unavailabilities: $unavailabilities) {
      id
      unavailabilities {
        from
        to
      }
    }
  }
`

/**
 * Provide handlers to update the selected user unavailabilities
 */
export default function useUnavailabilitiesHandlers() {
  // retrieve the currently selected user id
  const [userId] = useSelectedUserId()

  // retrieve the unavailabilities
  const { unavailabilities } = useSelectedUserUnavailabilities()

  // retrieve the currently connected user id
  const accountId = useAccountId()

  // get save mutation
  const [updateAccountUnavailabilities] = useMutation(accountMutation)
  const [updateUserUnavailabilities] = useMutation(userMutation, { variables: { userId } })
  const mutate = userId === accountId ? updateAccountUnavailabilities : updateUserUnavailabilities

  // provide a generic save handler for add/edit/remove
  const save = useHandler(unavailabilities => mutate({ variables: { unavailabilities } }))

  // provide data, save (add/edit) & remove handlers
  return {
    saveUnavailability: useHandler(({ unavailability, index }) =>
      save(putUnavailability(unavailability, unavailabilities, index))
    ),
    removeUnavailability: useHandler(index => save(removeUnavailability(unavailabilities, index))),
  }
}
